import { AddToCart } from '../cart/add-to-cart';
import Price from '../price';
import Prose from '../prose';
import { Product } from 'lib/burokshop/types';
import { VariantSelector } from './variant-selector';

export function ProductDescription({ product }: { product: Product }) {
  return (
    <>
      <div className="mb-6 flex flex-col border-b pb-6 dark:border-neutral-700">
        <h1 className="mb-2 text-5xl font-medium">{product.title}</h1>
        <div className="mr-auto w-auto rounded-full bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-600 p-2 text-sm text-white shadow-md">
          <Price
            amount={product.priceRange.maxVariantPrice.amount}
            currencyCode={product.priceRange.maxVariantPrice.currencyCode}
          />
        </div>
      </div>
      <VariantSelector options={product.options} variants={product.variants} />
      {product.descriptionHtml ? (
        <Prose
          className="mb-6 text-sm leading-tight dark:text-white/[60%]"
          html={product.descriptionHtml}
        />
      ) : null}
      <AddToCart product={product} />
      <button
        type="button"
        className="relative mt-4 flex w-full items-center justify-center gap-3 rounded-full bg-gradient-to-r from-orange-500 via-orange-400 to-orange-500 p-4 tracking-wide text-white shadow-lg transition-all hover:from-orange-600 hover:via-orange-500 hover:to-orange-600 hover:shadow-xl"
      >
        <img 
          src="/assets/images/BUROKLOGOTWITTER.png" 
          alt="Burok Logo" 
          className="h-6 w-6 object-contain"
        />
        <span className="font-semibold">Acheter dans l'application</span>
      </button>
    </>
  );
}



